import React, { Component } from "react";
import { connect } from "react-redux";
import { ReactComponent as WalletIcon } from "./assets/wallet.svg";
import "./index.css";
import TextField from "@material-ui/core/TextField";
import { Button, CircularProgress } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import instance from "../../../store/actions/instance";
import { withStyles } from "@material-ui/styles";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

const BlueTextField = withStyles({
  root: {
    "& .MuiInput-underline:before": {
      borderBottomColor: "#0099cc8", // Semi-transparent underline
    },
    "& .MuiInput-underline:hover:before": {
      borderBottomColor: "#0099cc", // Solid underline on hover
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#0099cc", // Solid underline on focus
    },
  },
})(TextField);

class Profile extends Component {
  state = {
    amount: 50,
    loading: false,
    error: "",
  };

  topup = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const res = await instance.post("/top_up_b2b_wallet/", {
        slug: this.props.slug,
        amount: this.state.amount,
      });
      if (res.data.success && res.data.url) {
        window.location.href = res.data.url;
      } else
        this.setState({ error: res.data.message || "Something went wrong" });
    } catch (err) {
      console.error(err);
      this.setState({ error: "Something went wrong" });
    }
    this.setState({ loading: false });
  };
  render() {
    const { data, language, settings } = this.props;
    const { amount, loading } = this.state;
    const currencyIcon = getCurrencyIcon(settings)
    const currencyIso = getCurrencyIcon(settings,language)
    return (
      <div className="mb-5 p-4">
        <div
          className="bold text-center"
          style={{ fontSize: 16, marginBottom: 30 }}
        >
          {language === "arabic" ? "الملف الشخصي" : "Profile"}
        </div>

        <p className={language === "arabic" ? "pageArTitle" : "pageEnTitle"}>
          <WalletIcon
            className={
              language === "arabic" ? "pageArTitleIcon" : "pageEnTitleIcon"
            }
          />
          {language === "arabic" ? "المحفظة" : "Wallet"}
        </p>
        <div
          className="px-4"
          style={{
            display: "grid",
            gridTemplateColumns: "75%",
            paddingTop: 22,
            paddingBottom: 6,
            background: "#0099cc",
            borderRadius: 5,
            color: "white",
            height: 112,
            textAlign: language === "arabic" ? "right" : "left",
            direction: language === "arabic" ? "rtl" : "ltr",
          }}
        >
          <div>
            <p className="mb-2 bold" style={{ marginTop: 5 }}>
              {language === "arabic" ? "رصيدك الحالي" : "Your balance"}
            </p>
            <h2 style={{ color: "white", fontWeight: "bold", marginTop: 0 }}>
              {data.balance.toFixed(settings.currency_decimals)}{" "}
              <span
                style={{ fontSize: 20 }}
                className={currencyIcon}
              >
                {language === "arabic"
                  ? settings.currency_local
                  : settings.currency_english}
              </span>
            </h2>
          </div>
          {/* 
          <div
            style={{
              alignSelf: "top",
              justifySelf: "start",
              alignSelf: "end",
              position: "relative",
              top: -18,
              left: -12,
            }}
          ></div> */}
        </div>

        {!!this.state.error && (
          <div
            className="my-3"
            style={{
              color: "red",
              textAlign: language === "arabic" ? "right" : "left",
            }}
          >
            {this.state.error}
          </div>
        )}

        <div
          className="px-4 mt-3"
          style={{
            paddingTop: 22,
            paddingBottom: 6,
            border: "1px solid #0099cc",
            borderRadius: 5,
            // height: 112,
            textAlign: language === "arabic" ? "right" : "left",
          }}
        >
          <p className="bold mb-2">
            {language === "arabic" ? "تعبئة رصيد" : "Top-up"}
          </p>

          <BlueTextField
            id="standard-number-input"
            label={language == "english" ? "Amount" : "المبلغ"}
            type="number"
            className="mb-1 mt-2"
            style={{
              width: "100%",
              direction: language == "english" ? "ltr" : "rtl",
            }}
            onChange={(e) => {
              this.setState({ amount: e.target.value });
            }}
            value={this.state.amount}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {currencyIso}
                </InputAdornment>
              ),
            }}
            FormHelperTextProps={{
              style: {
                textAlign: language == "english" ? "left" : "right",
              },
            }}
            InputLabelProps={{
              style: {
                transformOrigin:
                  language == "english" ? "top left" : "top right",
                right: language == "arabic" ? 0 : "unset",
                left: language == "english" ? 0 : "unset",
              },
            }}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                // validate();
              }
            }}
          />

          <div className="mt-3 mb-4">
            <Button
              variant="contained"
              disabled={amount <= 0}
              color="primary"
              style={{
                width: 100,
                boxShadow: "none",
                fontWeight: "bold",
                textTransform: "none",
                fontSize: 14,
                backgroundColor: "#0099cc",
                color: "white",
              }}
              onClick={() => this.topup()}
            >
              {loading === false ? (
                language === "english" ? (
                  "Pay now"
                ) : (
                  "ادفع الآن"
                )
              ) : (
                <CircularProgress
                  style={{ color: "white", width: 25, height: 25 }}
                />
              )}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Profile);
